import React, { useEffect } from 'react';
import { useApiResource } from '../../../../hooks/useApi';
import { SharedGroupedOrdersSummary } from '../../../groupedOrdersSummary/groupedOrdersSummary';
import { ordersApi } from '../../../../api/ordersApi';

export function ShopGroupedOrdersSummary({
  id,
  currencyCode,
  currencyPriceDecimalPlaces,
}: {
  id: number;
  currencyCode: string;
  currencyPriceDecimalPlaces: number;
}) {
  const groupedOrdersSummary = useApiResource(
    ordersApi.getGroupedOrdersSummary,
  );

  useEffect(() => {
    groupedOrdersSummary.refresh(id);
  }, [id]);

  return (
    <SharedGroupedOrdersSummary
      resource={groupedOrdersSummary}
      currencyCode={currencyCode}
      currencyPriceDecimalPlaces={currencyPriceDecimalPlaces}
    />
  );
}
